import { useEffect } from 'react';
import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { Link } from 'components/common';
import { Icon } from 'components/common/icons';
import { UpdatesContentEn, UpdatesContentFi } from '.';

export const latestProductUpdatesDate = Date.parse('2026-10-26');

const Updates = () => {
  const { dispatch } = useDispatch();
  const { language, messages, theme, user } = useReduxState();

  const updateProductUpdatesLastRead = async () => {
    try {
      if (
        latestProductUpdatesDate &&
        (!user.productUpdatesLastRead ||
          latestProductUpdatesDate >
            Date.parse(user.productUpdatesLastRead as string))
      ) {
        const productUpdatesLastRead = Date.now();
        await api.post('/auth/profile', { productUpdatesLastRead });
        dispatch.setUser({
          ...user,
          productUpdatesLastRead: new Date().toISOString()
        });
      }
    } catch (err) {
      console.error('could not update productUpdatesLastRead');
    }
  };

  useEffect(() => {
    updateProductUpdatesLastRead();
  }, []);

  return (
    <div className="updates">
      <div className="icon">
        <Icon icon="rocket" />
      </div>

      <h1 className="heading">{messages.updatesHeading}</h1>

      <p className="description">
        {`${messages.updatesDescription} `}
        <Link
          external={true}
          href="mailto:help@vuolearning.fi"
          text="help@vuolearning.fi"
        />
        {'.'}
      </p>

      <div className="content">
        {
          {
            'de-DE': <UpdatesContentEn />,
            'en-GB': <UpdatesContentEn />,
            'es-ES': <UpdatesContentEn />,
            'et-EE': <UpdatesContentEn />,
            'fi-FI': <UpdatesContentFi />,
            'fr-FR': <UpdatesContentEn />,
            'nb-NO': <UpdatesContentEn />,
            'pl-PL': <UpdatesContentEn />,
            'ru-RU': <UpdatesContentEn />,
            'sv-SE': <UpdatesContentEn />
          }[language]
        }
      </div>

      <style jsx>{`
        .updates {
          margin: 25px auto 0;
          max-width: 720px;
        }
        .icon {
          color: ${theme.pageTextColor || theme.textColor};
          font-size: 2rem;
          margin: 0 0 10px;
          text-align: center;
        }
        .heading {
          color: ${theme.pageTextColor || theme.textColor};
          font-size: 1.8rem;
          margin: 0 0 15px;
          text-align: center;
        }
        .description {
          color: ${theme.pageTextColorLighter || theme.textColorLighter};
          font-size: 1.6rem;
          margin: 0 auto 50px;
          max-width: 580px;
          text-align: center;
        }
        .content {
          color: ${theme.textColorLight};
          font-size: 1.6rem;
        }
      `}</style>
    </div>
  );
};

export default Updates;
